import type {
  AddMemberRequest,
  CreateGroupRequest,
  UpdateGroupRequest,
  UpdateMemberRequest,
  RenamePlaceholderRequest,
  GroupDetailResponse,
  GroupMemberResponse,
  GroupResponse,
} from "@qota/shared";
import { request } from "./http";

export function listGroups(): Promise<GroupResponse[]> {
  return request<GroupResponse[]>("GET", "/groups");
}

export function getGroup(groupId: string): Promise<GroupDetailResponse> {
  return request<GroupDetailResponse>("GET", `/groups/${groupId}`);
}

export function createGroup(input: CreateGroupRequest): Promise<GroupDetailResponse> {
  return request<GroupDetailResponse>("POST", "/groups", input);
}

export function listMembers(groupId: string): Promise<GroupMemberResponse[]> {
  return request<GroupMemberResponse[]>("GET", `/groups/${groupId}/members`);
}

export function addMember(groupId: string, input: AddMemberRequest): Promise<GroupMemberResponse> {
  return request<GroupMemberResponse>("POST", `/groups/${groupId}/members`, input);
}

export function removeMember(groupId: string, memberId: string): Promise<void> {
  return request<void>("DELETE", `/groups/${groupId}/members/${memberId}`);
}

export function updateGroup(
  groupId: string,
  input: UpdateGroupRequest,
): Promise<GroupDetailResponse> {
  return request<GroupDetailResponse>("PATCH", `/groups/${groupId}`, input);
}

export function deleteGroup(groupId: string): Promise<void> {
  return request<void>("DELETE", `/groups/${groupId}`);
}

export function updateMemberRole(
  groupId: string,
  memberId: string,
  input: UpdateMemberRequest,
): Promise<void> {
  return request<void>("PATCH", `/groups/${groupId}/members/${memberId}`, input);
}

export function renamePlaceholder(
  groupId: string,
  memberId: string,
  input: RenamePlaceholderRequest,
): Promise<void> {
  return request<void>("PATCH", `/groups/${groupId}/members/${memberId}/name`, input);
}
